export const offlineMode = process.env.NODE_ENV !== 'production';
export const backendDomain = offlineMode ? process.env.REACT_APP_OFFLINE_BACKEND_DOMAIN : process.env.REACT_APP_ONLINE_BACKEND_DOMAIN;
